import { Directive, Input, ElementRef, NgZone, Output, EventEmitter } from '@angular/core';

@Directive({
    selector: '[imagezoom]'
})
export class imagezoom {
    @Input('imagezoom') data: any;
    mousePosition: any = { x: null, y: null };
    dragStarted: number = 0;
    containerWidth = 800;
    containerHeight = 600;
    constructor(private _elementRef: ElementRef, private ngZone: NgZone) {
    }
    ngOnInit() {
        debugger;
        let el = this._elementRef.nativeElement;
        this.ngZone.runOutsideAngular(() => {
            var object = this;
            el.addEventListener('mousedown', (e) => {
                this.dragStarted = 1;
                var target = e.target != null ? e.target : e.srcElement;
                this.mousePosition = { x: e.pageX - 275, y: e.pageY - 400 };
                target.style.cursor = 'move';
            });
            el.addEventListener('mouseup', (e) => {
                this.dragStarted = 0;
                e.target.style.cursor = '';
            });
            el.addEventListener('mousemove', (e) => {
                var target = e.target.getElementsByClassName('imagepreview')[0] != null ? e.target.getElementsByClassName('imagepreview')[0] : e.srcElement;
                if (this.dragStarted == 1 && target.style.maxWidth != '100%') {
                    var current_mouse_position = { x: e.pageX - 275, y: e.pageY - 400 };
                    var change_x = current_mouse_position.x - this.mousePosition.x;
                    var change_y = current_mouse_position.y - this.mousePosition.y;
                    var top = parseInt(target.style.top.replace('px', '')) + change_y;
                    var left = parseInt(target.style.left.replace('px', '')) + change_x;
                    var imgheight = parseInt(target.style.height.replace('px', ''));
                    var imgwidth = parseInt(target.style.width.replace('px', ''));
                    this.mousePosition = current_mouse_position;
                    // if (top > 0)
                    //     top = 0;
                    // if(top < (this.containerHeight - 500))
                    //     top = this.containerHeight - 500;
                    if (target.style.left == '') {
                        target.style.left = '0px'
                    }
                    if (target.style.top == '') {
                        target.style.top = '0px'
                    }
                    else {
                        if(top <= 0 && top > -(imgheight - this.containerHeight) )
                        target.style.top = top + 'px';
                        if(left <= 0 && left > -(imgwidth - this.containerWidth) )
                        target.style.left = left + 'px';
                    }
                }
            });
        });
    }
}